import { useTranslation } from 'react-i18next';
import { Filter } from '@anytag/shared-molecules';
import { usePackageContentInfluencersSearch } from '../PackageContentList';
import { Template } from './Template';

export interface PackageContentFilterProps {
  loading: boolean;
}

export const PackageContentFilter = ({ loading }: PackageContentFilterProps) => {
  const { t } = useTranslation();
  const { filter, setFilterForm } = usePackageContentInfluencersSearch();

  return (
    <>
      <div className="box-border flex h-12 items-center justify-between border-t border-b border-border bg-white px-4 py-2">
        <h3 className="text-lg leading-4 font-semibold">{t('Influencers')}</h3>
      </div>

      <Filter.Provider onSubmit={setFilterForm} values={filter} className="px-4 pt-2 pb-0">
        <Template loading={loading} />
      </Filter.Provider>
    </>
  );
};
